import {Home, Inputs, Palette, Typography, Biometrics} from 'modules/demo';
import {RouteItem} from 'commons/types/Types';
import Modal from 'modules/demo/modal/Modal';

export const demoRoutes: Array<RouteItem> = [
    {
        path: '/demo',
        exact: true,
        name: 'Inicio',
        icon: '',
        component: Home,
        layout: '/blank',
    },
    {
        path: '/palette',
        exact: false,
        name: 'Palette',
        icon: '',
        component: Palette,
        layout: '/blank',
    },
    {
        path: '/typography',
        exact: false,
        name: 'Typography',
        icon: '',
        component: Typography,
        layout: '/blank',
    },
    {
        path: '/inputs',
        exact: false,
        name: 'Inputs',
        icon: '',
        component: Inputs,
        layout: '/blank',
    },
    {
        path: '/modal',
        exact: false,
        name: 'Modal',
        icon: '',
        component: Modal,
        layout: '/blank',
    },
    {
        path: '/biometrics',
        exact: false,
        name: 'Biometrics',
        icon: '',
        component: Biometrics,
        layout: '/blank',
    }
];
